module.exports = __webpack_public_path__ + "static/media/portada.12249b24.png";